import React from 'react'
import "./common.css"
import logo from "../../../assets/images/logo.svg"
import { MdHome } from "react-icons/md";
import FAQ from "../../../assets/images/FAQ.PNG"
import { Link } from "react-router-dom";

const CommonHeader = (props) => {

  return (
    <>
    <div className='commonHeaderContainer ' >
        <div className='two-col'>
          <Link to="/"> 
            <img src={logo} alt="Torfacts" className="brand-logo-common mb-5" />
            </Link>
        </div>
        <div className='two-col text-right'>
            <Link to="/" className='backtohome'> <MdHome /> Home</Link>
        </div>
    </div>
    {props.id!==4 ? (<>
    <div className='page-title  mb-50'>
      <div className='pt-left'>
         <h2 className='pageTitle'>{props.title}</h2>
        <p>{props.stitle}</p>
      </div>
      <div className='pt-right'>
        <img src={FAQ} alt="FAQ" className='pt-img' />
      </div>
    </div>
    </>) : (<></>) }    
    </>
  )
}

export default CommonHeader